import type { RouteRecordName } from 'vue-router'

import { pathNames } from '@/shared/utils/constants'

const CONTENT_ROUTE_NAMES: ReadonlySet<string> = new Set([
  pathNames.CHAT,
  pathNames.CALL_SESSION,
  pathNames.PREPARE_TO_CALL,
  pathNames.CALENDAR,
])

export const isContentRouteName = (name: RouteRecordName | null | undefined): boolean => (
  typeof name === 'string' && CONTENT_ROUTE_NAMES.has(name)
)
